"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJavaRuntimeReleaseContent = exports.getJavaRuntimeReleaseAction = void 0;
const path_1 = require("path");
const extractor_1 = require("../../extractor");
const stream_utils_1 = require("../../stream-utils");
function javaReleaseFilePathMatches(filePath) {
    const p = (0, path_1.normalize)(filePath);
    const isReleaseFile = (0, path_1.basename)(p) === "release";
    const matched = 
    // eclipse-temurin: /opt/java/openjdk/release
    p === (0, path_1.normalize)("/opt/java/openjdk/release") ||
        // official Docker openjdk: /usr/local/openjdk-<version>/release
        (p.startsWith((0, path_1.normalize)("/usr/local/openjdk-")) && isReleaseFile) ||
        // Any JVM installed under /usr/lib/jvm/ (Debian/Ubuntu openjdk, Azul Zulu, Amazon Corretto, Temurin, etc.)
        (p.startsWith((0, path_1.normalize)("/usr/lib/jvm/")) && isReleaseFile) ||
        // Oracle JDK: /usr/java/<version>/release
        (p.startsWith((0, path_1.normalize)("/usr/java/")) && isReleaseFile);
    return matched;
}
exports.getJavaRuntimeReleaseAction = {
    actionName: "java-runtime-release",
    filePathMatches: javaReleaseFilePathMatches,
    callback: stream_utils_1.streamToString,
};
function getJavaRuntimeReleaseContent(extractedLayers) {
    const content = (0, extractor_1.getContentAsString)(extractedLayers, exports.getJavaRuntimeReleaseAction);
    return content || "";
}
exports.getJavaRuntimeReleaseContent = getJavaRuntimeReleaseContent;
//# sourceMappingURL=static.js.map